import { Autocomplete, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, TextField } from "@mui/material";
import { BRAND_MONTH_OPTIONS, getBrandYearOptions } from "./brandsMonthYearOptions";

interface BrandsFilterItemsProps {
  options: string[];
  selectedBrand: string;
  onSelectedBrandChange: (brand: string) => void;
  selectedMonth: number;
  onSelectedMonthChange: (month: number) => void;
  selectedYear: number;
  onSelectedYearChange: (year: number) => void;
  disableMonthYear?: boolean;
}

export default function BrandsFilterItems({
  options,
  selectedBrand,
  onSelectedBrandChange,
  selectedMonth,
  onSelectedMonthChange,
  selectedYear,
  onSelectedYearChange,
  disableMonthYear = false,
}: BrandsFilterItemsProps) {
  const yearOptions = getBrandYearOptions();

  const handleMonthChange = (event: SelectChangeEvent<number>) => {
    onSelectedMonthChange(Number(event.target.value));
  };

  const handleYearChange = (event: SelectChangeEvent<number>) => {
    onSelectedYearChange(Number(event.target.value));
  };

  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
      <Autocomplete
        disableClearable
        disablePortal
        freeSolo={false}
        options={options}
        value={selectedBrand}
        onChange={(_event, newValue) => onSelectedBrandChange(newValue)}
        sx={{ minWidth: 220 }}
        data-tracker="976"
        noOptionsText="No options"
        renderInput={(params) => (
          <TextField {...params} label="Brand" size="small" color="secondary" />
        )}
      />
      <FormControl size="small" color="secondary" sx={{ minWidth: 160 }} disabled={disableMonthYear}>
        <InputLabel color="secondary">Month</InputLabel>
        <Select
          label="Month"
          value={selectedMonth}
          onChange={handleMonthChange}
          color="secondary"
          data-tracker="1040"
          MenuProps={{ disablePortal: true }}
        >
          {BRAND_MONTH_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" color="secondary" sx={{ minWidth: 120 }} disabled={disableMonthYear}>
        <InputLabel color="secondary">Year</InputLabel>
        <Select
          label="Year"
          value={selectedYear}
          onChange={handleYearChange}
          color="secondary"
          data-tracker="1041"
          MenuProps={{ disablePortal: true }}
        >
          {yearOptions.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
